
/**
  * @ngdoc filter
  * @name common.filter:t
  * @function
  * ItxTranslateFlt
  * @description
  * Calls `inditex.text` function with the value of the description. If a dynamic variable is set, it will be replace with
  * correspodent value.
  *
  * @param {string} value Translation key from lokalise
  * @param {string} param Optional dynamic parameter
  * @returns {string} Translated text
  * @example 
  * # Direct translation
  * <pre>
  * <span>{{ 'legacy.ItxShopCartView.cesta.total' | tCms }}</span>
  * Output 
  * <span>Total</span>
  * </pre>
  * # Translations with params 
  * Dynamic translation where it replace the ``${}`` with ``inditex.iStoreJSON.countryCode``
  * <pre>
  * <span ng-message="zipCode" class="text-danger">{{ 'Messages_zipCode_${}'| t: 'countryCode'}}</span>
  * Output
  * <span ng-message="zipCode" class="text-danger">Introduzca un código postal válido (28000)</span>
  * </pre>
*/
(function() {

    'use strict';

    angular
    .module('itxApp.common')
    .filter('t', ItxTranslateFlt);

    ItxTranslateFlt.$inject = ['ItxConfigurationSvc'];

    function ItxTranslateFlt(ItxConfigurationSvc) {

        var showProperties = false;
        if(ItxConfigurationSvc.isDebugActive()){
            showProperties = ItxConfigurationSvc.getDebugOptions().properties;
        }

        var duttiParam = 'Dutti' + inditex.iCountryCode;

        return function(value, param) {
                        
            if(showProperties){
                return value;
            }else { 
                

                if(param && param.length > 1 && param[2]!='isZipCode') {
                    if(angular.isArray(param)){

                        param[0] = value.replace('${}', inditex.iStoreJSON.countryCode);

                        return inditex.text.apply(this, param );

                    } else{
                        
                        var text = value.replace('${}',inditex.iStoreJSON.countryCode);

                        return inditex.text(text);

                    }
                }

                // Gestion para país idioma
                if(param && param.length > 1 && param[2] == 'isZipCode'){
                    var translateValue = inditex.text(value + '.' + 'Dutti' + param[1],param[0]);
                } else {
                    var translateValue = inditex.text(value + '.' + duttiParam,param);
                }
                
                // logger.log('ItxTranslateFlt translateValue 1 ', translateValue);

                if( _.includes( translateValue, '???') ){
                    translateValue = inditex.text(value,param);
                }

                // logger.log('ItxTranslateFlt translateValue 2 ', translateValue);

                return translateValue;
            }
        };
    }
    
})();